
import { useState, useEffect } from "react";
import { useProfileData } from "./statistics/useProfileData";
import { useEntriesData } from "./statistics/useEntriesData";
import { useUnitPreferences } from "./statistics/useUnitPreferences";
import { useGrowthData } from "./statistics/useGrowthData";

export function useStatisticsData() {
  // Use the focused hooks
  const { 
    user,
    babyProfile,
    familyProfile,
    useMetricHeight,
    useMetricWeight,
    isLoading: profileLoading,
    babyAgeInMonths,
    refreshProfiles
  } = useProfileData();
  
  const {
    timeRange,
    setTimeRange,
    getFilteredEntries
  } = useEntriesData(user?.id);
  
  // State for tracking unit preferences locally
  const [localMetricHeight, setLocalMetricHeight] = useState(useMetricHeight);
  const [localMetricWeight, setLocalMetricWeight] = useState(useMetricWeight);
  
  // Update local unit preferences when the profile preferences change
  useEffect(() => {
    setLocalMetricHeight(useMetricHeight);
    setLocalMetricWeight(useMetricWeight);
  }, [useMetricHeight, useMetricWeight]);
  
  const {
    displayOriginalHeight,
    displayOriginalWeight,
    handleHeightUnitToggle: baseHeightUnitToggle,
    handleWeightUnitToggle: baseWeightUnitToggle
  } = useUnitPreferences(babyProfile, localMetricHeight, localMetricWeight);
  
  // Filter entries based on time range
  const filteredEntries = getFilteredEntries();
  
  // Process growth data with updated unit preferences
  const { heightData, weightData, milkData } = useGrowthData(
    filteredEntries, 
    localMetricHeight, 
    localMetricWeight
  );
  
  // Unit toggle handlers with local state
  const handleHeightUnitToggle = async () => {
    const newPreference = await baseHeightUnitToggle();
    console.log("[useStatisticsData] Height unit toggled to:", newPreference ? "metric" : "imperial");
    setLocalMetricHeight(newPreference);
    return newPreference;
  };
  
  const handleWeightUnitToggle = async () => {
    const newPreference = await baseWeightUnitToggle();
    console.log("[useStatisticsData] Weight unit toggled to:", newPreference ? "metric" : "imperial");
    setLocalMetricWeight(newPreference);
    return newPreference;
  };

  return {
    user,
    isLoading: profileLoading,
    timeRange,
    setTimeRange,
    heightData,
    weightData,
    milkData,
    displayOriginalHeight,
    displayOriginalWeight,
    useMetricHeight: localMetricHeight,
    useMetricWeight: localMetricWeight,
    handleHeightUnitToggle,
    handleWeightUnitToggle,
    refreshProfiles,
    familyProfile,
    babyAgeInMonths
  };
}
